import { CustomFieldType, CustomFieldLocaleDataBuilder } from '../domain/tickets';
var ResolvedCustomFieldBuilder = /** @class */ (function () {
    function ResolvedCustomFieldBuilder() {
        this.field = {
            id: '1239032-21323190321903219',
            type: CustomFieldType.TEXT,
            mandatory: false,
            name: 'Bob Custom',
            data: new CustomFieldLocaleDataBuilder().build()
        };
    }
    ResolvedCustomFieldBuilder.prototype.withId = function (id) {
        this.field.id = id;
        return this;
    };
    ResolvedCustomFieldBuilder.prototype.withType = function (type) {
        this.field.type = type;
        return this;
    };
    ResolvedCustomFieldBuilder.prototype.withMandatory = function (mandatory) {
        this.field.mandatory = mandatory;
        return this;
    };
    ResolvedCustomFieldBuilder.prototype.withName = function (name) {
        this.field.name = name;
        return this;
    };
    ResolvedCustomFieldBuilder.prototype.withData = function (data) {
        this.field.data = data;
        return this;
    };
    ResolvedCustomFieldBuilder.prototype.withValidator = function (validator) {
        this.field.validator = validator;
        return this;
    };
    ResolvedCustomFieldBuilder.prototype.withMultiLevelData = function (data) {
        this.field.multiLevelData = data;
        return this;
    };
    ResolvedCustomFieldBuilder.prototype.build = function () {
        return this.field;
    };
    return ResolvedCustomFieldBuilder;
}());
export { ResolvedCustomFieldBuilder };
;
//# sourceMappingURL=resolved-custom-field.builder.js.map